import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export type APIError = ApiFieldError;

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/TEAMMEMBER`
);
export type CreateTeamMemberParams = any;
export type UpdateTeamMemberParams = any;

export const updateSingleTeamMemberInStore = actionCreator<any>(
  'update-single-teammember'
);
export const describeteamMemberActions = actionCreator.async<
  any,
  any,
  APIError[]
>('request-teammember');

export const teamMemberRequest = actionCreator<string>('request');
export const update = actionCreator<any>('update');

export const teamMemberRequestSuccess = actionCreator<any>('success');

export const teamMemberRequestById = actionCreator('teammember-request');

export const teamMemberRequestSuccessById =
  actionCreator<any>('teammember-success');

export const teamMemberRequestFailById =
  actionCreator<string>('teammember-fail');

export const teamMemberRequestFail = actionCreator<APIError[]>('fail');
export const createTeamMemberActions = actionCreator.async<
  CreateTeamMemberParams,
  any,
  APIError[]
>(`create`);
export const updateTeamMemberActions = actionCreator.async<
  UpdateTeamMemberParams,
  any,
  APIError[]
>(`update`);
